import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Container, Row } from '@yme/atoms/grid';
import { IndentWrapper } from '@yme/components/Separator';
import { SegmentPreviewCard } from '@yme/molecules/cards';
import { SectionWrapper } from '@yme/molecules/section-wrapper';
import { getRTL } from '@yme/selectors/common';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { buildKey } from '@yme/utils/common';
import { DATA_TEST_ID } from './constants';
export function CategorySelectorPanel(props) {
    const { header, categories, isRemoveBottomIndent } = props;
    const isRightToLeft = useSelector(getRTL);
    if (!header) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(Container, { dataTestId: DATA_TEST_ID },
            React.createElement(SectionWrapper, { headerLeftSide: header, isRightToLeft: isRightToLeft, bgColor: colorCoreWhite1000, isVerticalIndentDefault: true },
                React.createElement(Row, { rowGap: "24px" }, categories.map((category, index) => {
                    const { title, image, link } = category;
                    return (React.createElement(Col, { lg: 2, md: 2, sm: 2, key: buildKey(category.title, index) },
                        React.createElement(SegmentPreviewCard, { title: title, imageObj: image, link: link, isRightToLeft: isRightToLeft, bottomIndent: "12px" })));
                }))))));
}
CategorySelectorPanel.displayName = 'CategorySelectorPanel_AEMComponent';
